export const getUserMenuItems = (isAuth) => {
  if (!isAuth) {
    return [
      {label: 'Iniciar Sesión', route: '/iniciar-sesion'},
      {label: 'Crear Cuenta', route: '/crear-cuenta'},
      {label: 'Modificar Contraseña', route: '/solicitar-nueva-contrasena'}
    ]
  }

  return [
    {label: 'Perfil', route: '/zona-de-cliente/perfil'},
    //{label: 'Datos de Facturación', route: '/zona-de-cliente/facturacion'},
    //{label: 'Datos de Envío', route: '/zona-de-cliente/envio'},
    {separator: true},
    {label: 'Mis Cursos', route: '/zona-de-cliente/cursos'},
    {label: 'Mis Pedidos', route: '/zona-de-cliente/pedidos'},
    {separator: true},
    {label: 'Cerrar Sesión', route: '/logout'}
  ]
}

export const getStaticRightMenuItems = (cartItemsCount, searchCommand) => {
  return [
    {
      type: 'icon_text',
      label: '',
      icon: 'pi pi-search',
      command: searchCommand,
      items: [],
      excludeMobile: true
    },
    {
      type: 'icon',
      label: '',
      badge: cartItemsCount,
      icon: 'pi pi-shopping-bag',
      url: '/compra',
      items: [],
      excludeMobile: true
    }
  ]
}
